<template>
  <div class="auth">
    <amplify-authenticator :services="services"></amplify-authenticator>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  name: "auth",
  data() {
    return {
      services: {
        Auth: {
          ...Auth,
          signUp: async (params) => {
            const { username } = params;
            if (!username.endsWith('@spotter.la')) {
              throw new Error('Only Spotter employee are allowed to SignUp!');
            }
            return Auth.signUp(params);
          },
          signIn: async (username, password) => {
            if (!username.endsWith('@spotter.la')) {
              throw new Error('Only Spotter employee are allowed to signIn!');
            }
            return Auth.signIn(username, password);
          }
        }
      }
    };
  }
};
</script>

<style>
.auth {
  margin: 0 auto;
  width: 460px;
}
</style>